import ApiService from "./api.service";
import dayjs from "dayjs";

const Subcontractors = {
    create: async function (data) {
        if (data.exemption_certificate_valid_to instanceof Date) {
            data.exemption_certificate_valid_to = dayjs(data.exemption_certificate_valid_to).format('YYYY-MM-DD');
        }
        if (data.insurance_valid_to instanceof Date) {
            data.insurance_valid_to = dayjs(data.insurance_valid_to).format('YYYY-MM-DD');
        }

        let response = await ApiService.post("/subcontractor", data, "subcontractor was created");
        return response.data;
    },
    update: async function (user_id, data) {
        data.exemption_certificate_valid_to = (data.exemption_certificate_valid_to instanceof Date) ? dayjs(data.exemption_certificate_valid_to).format('YYYY-MM-DD') : null;
        data.insurance_valid_to = (data.insurance_valid_to instanceof Date) ? dayjs(data.insurance_valid_to).format('YYYY-MM-DD') : null;
        let response = await ApiService.put("/subcontractor/" + user_id, data, "subcontractor profile was updated");
        return response.data;
    },
    delete: async function (user_id) {
        await ApiService.delete("/subcontractor/" + user_id, {}, "subcontractor was deleted");
        return true;
    },
    search: async function (search) {
        let query = (search) ? {
            q: search
        } : {};
        let response = await ApiService.get("/subcontractors", query);
        return response.data.subcontractors;
    },
    available: async function () {
        let response = await ApiService.get("/subcontractors/available");
        return response.data.subcontractors;
    }
};

export default Subcontractors;